export default __webpack_public_path__ + "static/media/sign-in-banner-new.e8590106.png";